<div id="job-openings" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h1 class="title">Job Openings</h1>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College regularly announces job openings for teaching and non-teaching positions. Interested candidates may apply through the online application form below. All applications are reviewed in accordance with the UGC/Haryana Government norms.
    </p>

    <hr class="divider">

    <div class="row g-3 mt-2">
      <div class="col-md-6">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLScds7YKPLzgaAronra-Ki9bHRp-N2tkyuSJ46aFTqkm83ni-g/viewform" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-edit me-2"></i>Apply for Job Openings
        </a>
      </div>
    </div>

    <p class="mt-4 text-muted">
      <em>Note: Current vacancies are listed in the online application form. Please check the form for the latest openings.</em>
    </p>

  </div>
</div>
